import {
  facilityTypeToString,
  facilityStatusToString,
  workScheduleOverrideReasonToString,
  workScheduleTypeToString,
} from "features/planner/planner.mappers";

import { formatDate } from "utils/format.util";
import { CARD_CONTAINER_TYPE } from "features/planner/planner.constants";

export const filterLocation = (filter, location) => {
  if (!filter) return true;

  return [
    location.name,
    formatDate(location.modified),
    location.field && location.field.name,
    location.facility && location.facility.operator,
    location.facility && facilityTypeToString(location.facility.type),
    location.facility && facilityStatusToString(location.facility.status),
    location.modifiedBy,
  ]
    .filter(Boolean)
    .some(value => value.toLowerCase().includes(filter.trim().toLowerCase()));
};

export const filterGroup = (filter, group) => {
  if (!filter) return true;

  return [group.name, formatDate(group.modified), group.modifiedBy]
    .filter(Boolean)
    .some(value => value.toLowerCase().includes(filter.trim().toLowerCase()));
};

export const filterWorkScheduleOverride = (filter, workScheduleOverride) => {
  if (!filter) return true;

  return [
    workScheduleOverrideReasonToString(workScheduleOverride.reason),
    workScheduleOverride.notes,
    formatDate(workScheduleOverride.startDate),
    formatDate(workScheduleOverride.endDate),
    formatDate(workScheduleOverride.modified),
    workScheduleOverride.modifiedBy,
  ]
    .filter(Boolean)
    .some(value => value.toLowerCase().includes(filter.trim().toLowerCase()));
};

export const getWorkScheduleReportTooltip = (reason, type) => {
  return `${workScheduleTypeToString(
    type,
  )} (${workScheduleOverrideReasonToString(reason)})`;
};

export const isDeploymentOffshore = (
  sourceCardContainer,
  targetCardContainer,
) =>
  sourceCardContainer.get("type") === CARD_CONTAINER_TYPE.ALLOCATED_OFFSHORE &&
  targetCardContainer.get("type") === CARD_CONTAINER_TYPE.DEPLOYED_OFFSHORE;

export const isShuttle = (sourceCardContainer, targetCardContainer) =>
  sourceCardContainer.get("type") === CARD_CONTAINER_TYPE.DEPLOYED_OFFSHORE &&
  targetCardContainer.get("type") === CARD_CONTAINER_TYPE.DEPLOYED_OFFSHORE &&
  sourceCardContainer.get("id") !== targetCardContainer.get("id");

export const isReturnOnshore = (sourceCardContainer, targetCardContainer) =>
  sourceCardContainer.get("type") === CARD_CONTAINER_TYPE.DEPLOYED_OFFSHORE &&
  targetCardContainer.get("type") === CARD_CONTAINER_TYPE.ONSHORE;

export const isAllocated = (
  { sourceGroupId, targetGroupId },
  targetCardContainer,
) =>
  sourceGroupId !== targetGroupId &&
  targetCardContainer.get("type") === CARD_CONTAINER_TYPE.ALLOCATED_OFFSHORE;
